/**
 * Internal dependencies
 */
import StoryPropTypes from '../../types';

function LottieOutput({ element }) {
  const { previewImageUrl, title } = element;

  if (previewImageUrl) {
    return (
      <amp-img
        className="fill"
        layout="fill"
        src={previewImageUrl}
        alt={title || ''}
      />
    );
  }

  return <div className="fill" data-lottie-placeholder="" />;
}

LottieOutput.propTypes = {
  element: StoryPropTypes.elements.lottie.isRequired,
};

export default LottieOutput;
